import {
  DeviceCareCenter,
  DeviceCareCenterResponse,
} from '../../models/device-care-center.model';

type DeviceCareCenterResponseWithFallbacks = DeviceCareCenterResponse & {
  consolidation_time?: string | null;
  order_consolidation_time?: string | null;
  orderConsolidationTimeUtc?: string | null;
  orderConsolidationTime?: string | null;
};

export function mapDeviceCareCenterResponseToModel(
  response: DeviceCareCenterResponse,
): DeviceCareCenter {
  const detailResponse = response as DeviceCareCenterResponseWithFallbacks;

  return {
    code: response.code,
    name: response.name,
    address1: response.address_1,
    address2: response.address_2,
    city: response.city,
    state: response.state,
    county: response.county,
    country: response.country,
    postalCode: response.postal_code,
    orderConsolidationTimeUtc:
      detailResponse.order_consolidation_time_utc ??
      detailResponse.consolidation_time ??
      detailResponse.order_consolidation_time ??
      detailResponse.orderConsolidationTimeUtc ??
      detailResponse.orderConsolidationTime ??
      null,
    createdOn: new Date(response.created_on),
    updatedOn: new Date(response.updated_on),
  };
}
